module.exports = __webpack_public_path__ + "static/media/app_btn_mania.e16a63dc.png";